import React, { Component } from 'react';

import { Table, TableBody, TableCell, TableHead, TableRow, IconButton } from '@material-ui/core';
import { Close as CloseIcon, Search as SearchIcon } from '@material-ui/icons';

import ErrorDialog from './ErrorDialog';

var request = require('../../utilities/NetworkRequest');
var cache_util = require('../../utilities/CacheUtil');

export default class ProductPickerDialog extends Component {

  constructor(props) {
    super(props);
    this.state = {
      search_text : '',
      selected_index : -1,
      products : [],
      is_loading : false,
      error : {
        is_show : false,
        message : ''
      }
    };
    this.search_timeout = null;
  }

  componentDidMount() {
    this.user_info = cache_util.onGetCacheData(cache_util.CACHE_INFO).result.user_information;
  }

  onSearchChange(event) {
    this.setState({ search_text : event.target.value, selected_index : -1 });

    if (this.search_timeout) {
      clearTimeout(this.search_timeout);
    }

    this.search_timeout = setTimeout(() => {
      this.fetchProducts();
    }, 300);
  }

  fetchProducts() {
    const search_text = this.state.search_text.trim();
    if (search_text === '') {
      this.setState({ products : [], is_loading : false });
      return;
    }

    const user_info = this.user_info || cache_util.onGetCacheData(cache_util.CACHE_INFO).result.user_information;
    const is_admin = user_info.wholesaler_id === 'TP9999';
    const wholesalerIdsFromProps = Array.isArray(this.props.wholesaler_ids)
      ? this.props.wholesaler_ids.filter(id => id && String(id).trim() !== '')
      : [];

    const body = {
      wholesaler_id : user_info.wholesaler_id,
      wholesaler_ids : (is_admin && wholesalerIdsFromProps.length > 0)
        ? JSON.stringify(wholesalerIdsFromProps)
        : null,
      retail_id : user_info.retail_id || 'WEB_USER',
      size : 50,
      page : 1,
      text : search_text,
      is_new : 'null',
      is_promo : 'null',
      is_favourite : 'null',
      isCategoryNeeded : '0',
      view_id : '/show/products/details'
    };

    const filter = [{
      type : 'input_free_text',
      key : 'product.pcode_name',
      description : 'Nama / Kode Produk',
      value : search_text
    }];
    body.filter = JSON.stringify(filter);

    this.setState({ is_loading : true }, () => {
      request.onRequestData(request.OPTION_API_MAIN, '/show/products/details', body, (res_data) => {
        if (res_data && res_data.code === 1) {
          const mapped = (res_data.result.product || []).map(p => ({
            code : p.product_id,
            name : p.name,
            img_tiny : p.img_tiny,
            uom_selected: p.unit_level.length > 0 ? p.unit_level[0].id : null
          }));
          this.setState({ products : mapped, is_loading : false });
        } else {
          this.setState({
            products : [],
            is_loading : false,
            error : {
              is_show : true,
              message : (res_data && res_data.message) ? res_data.message : 'Gagal memuat daftar produk'
            }
          });
        }
      });
    });
  }

  onKeyDown(event) {
    if (event.key === 'Escape') {
      this.props.onCloseListener('close', null);
    } else if (event.key === 'Enter' && this.state.selected_index >= 0 && this.state.products[this.state.selected_index]) {
      event.preventDefault();
      this.onSelectRow(this.state.products[this.state.selected_index]);
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (this.state.products.length > 0) {
        this.setState(prev => ({
          selected_index : Math.min(prev.selected_index + 1, prev.products.length - 1)
        }));
      }
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (this.state.products.length > 0) {
        this.setState(prev => ({
          selected_index : Math.max(prev.selected_index - 1, -1)
        }));
      }
    }
  }

  onSelectRow(row) {
    this.props.onCloseListener('select', row);
  }

  closeErrorDialog() {
    this.setState({ error : { is_show : false, message : '' } });
  }

  render() {
    const { search_text, selected_index, products, is_loading, error } = this.state;

    const renderBody = () => {
      if (search_text.trim() === '') {
        return (
          <TableRow>
            <TableCell colSpan={3} style={{ textAlign: 'center', color: '#999', fontStyle: 'italic', padding: '20px 0' }}>
              Ketik untuk mencari produk...
            </TableCell>
          </TableRow>
        );
      }
      if (is_loading) {
        return (
          <TableRow>
            <TableCell colSpan={3} style={{ textAlign: 'center', color: '#999', padding: '20px 0' }}>
              <span className='default_text_normal_gray'>Mencari produk...</span>
            </TableCell>
          </TableRow>
        );
      }
      if (products.length === 0) {
        return (
          <TableRow>
            <TableCell colSpan={3} style={{ textAlign: 'center', color: '#999', fontStyle: 'italic', padding: '20px 0' }}>
              Produk tidak ditemukan
            </TableCell>
          </TableRow>
        );
      }
      return products.map((row, idx) => (
        <TableRow
          key={row.code}
          hover
          onClick={() => this.onSelectRow(row)}
          onMouseEnter={() => this.setState({ selected_index : idx })}
          style={{
            cursor: 'pointer',
            backgroundColor: selected_index === idx ? '#e3f2fd' : 'transparent'
          }}
        >
          <TableCell>{row.code}</TableCell>
          <TableCell>{row.name}</TableCell>
          <TableCell style={{ width: 56, padding: '4px 8px' }}>
            {row.img_tiny ? (
              <img
                src={row.img_tiny}
                alt={row.name}
                style={{ width: 36, height: 36, objectFit: 'cover', borderRadius: 4, border: '1px solid #eee' }}
              />
            ) : (
              <div style={{ width: 36, height: 36, backgroundColor: '#f5f5f5', borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #eee' }}>
                <span style={{ fontSize: 9, color: '#999' }}>NoImg</span>
              </div>
            )}
          </TableCell>
        </TableRow>
      ));
    };

    return (
      <div onClick={() => this.props.onCloseListener('close', null)} className='process_dialog_root layer_a'>
        { error.is_show && <ErrorDialog body_error={error} onCloseDialog={() => this.closeErrorDialog()} /> }
        <div onClick={(e) => e.stopPropagation()} className='process_dialog_container' style={{ width: 600, maxWidth: '90vw', maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
          {/* Header */}
          <div className='title_search_container blue_background'>
            <div className='full_flex default_text_medium_white bold_text'>Pilih Produk</div>
            <IconButton size='small' onClick={() => this.props.onCloseListener('close', null)} style={{ color: '#fff' }}>
              <CloseIcon fontSize='small' />
            </IconButton>
          </div>

          {/* Search */}
          <div style={{ padding: 12, borderBottom: '1px solid #eee' }}>
            <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#f5f5f5', borderRadius: 4, padding: '6px 10px' }}>
              <SearchIcon fontSize='small' style={{ color: '#999', marginRight: 6 }} />
              <input
                type='text'
                value={search_text}
                onChange={(e) => this.onSearchChange(e)}
                onKeyDown={(e) => this.onKeyDown(e)}
                placeholder='Cari kode atau nama produk...'
                style={{ flex: 1, border: 'none', outline: 'none', backgroundColor: 'transparent', fontSize: 13 }}
                className='default_text_normal_gray non_transparent_input'
                autoFocus
              />
            </div>
          </div>

          {/* Table */}
          <div style={{ flex: 1, overflowY: 'auto' }}>
            <Table size='small'>
              <TableHead>
                <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                  <TableCell style={{ fontWeight: 'bold' }}>Kode Produk</TableCell>
                  <TableCell style={{ fontWeight: 'bold' }}>Nama Produk</TableCell>
                  <TableCell style={{ width: 56, fontWeight: 'bold' }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {renderBody()}
              </TableBody>
            </Table>
          </div>

          {/* Footer */}
          <div style={{ padding: '8px 12px', backgroundColor: '#f5f5f5', borderTop: '1px solid #eee', fontSize: 11, color: '#999' }}>
            Tekan ↑↓ untuk navigasi, Enter untuk pilih, Esc untuk tutup
          </div>
        </div>
      </div>
    );
  }

}